import { getBuilderSectionFromCollections } from './builderCollections';

export const getProductSection = (product) => {
    const collections = product.collections?.edges?.map((edge) => edge.node.title.toLowerCase()) || [];
    const tags = product.tags?.map((tag) => tag.toLowerCase()) || [];

    console.log('Determining section for product:', product.title);
    console.log('Collections:', collections);
    console.log('Tags:', tags);

    const configuredSection = getBuilderSectionFromCollections(product);
    if (configuredSection) {
        console.log('Matched via configured builder collection -> section:', configuredSection);
        return configuredSection;
    }

    for (const collection of collections) {
        if (collection.includes('hair') || collection.includes('hat') || collection.includes('wig')) {
            console.log('Matched hatsAndHair via collection keyword:', collection);
            return 'hatsAndHair';
        }
        if (collection.includes('head') || collection.includes('face')) {
            console.log('Matched heads via collection keyword:', collection);
            return 'heads';
        }
        if (collection.includes('torso') || collection.includes('body')) {
            console.log('Matched bodies via collection keyword:', collection);
            return 'bodies';
        }
        if (collection.includes('leg') && !collection.includes('lego')) {
            console.log('Matched legs via collection keyword:', collection);
            return 'legs';
        }
        if (collection.includes('display') || collection.includes('base')) {
            console.log('Matched display via collection keyword:', collection);
            return 'display';
        }
        if (collection.includes('accessory') || collection.includes('weapon') || collection.includes('tool')) {
            console.log('Matched accessories via collection keyword:', collection);
            return 'accessories';
        }
    }

    for (const tag of tags) {
        if ((tag.includes('hair') || tag.includes('hat') || tag.includes('wig')) && !tag.includes('lego')) {
            console.log('Matched hatsAndHair via tag:', tag);
            return 'hatsAndHair';
        }
        if ((tag.includes('head') || tag.includes('face')) && !tag.includes('lego')) {
            console.log('Matched heads via tag:', tag);
            return 'heads';
        }
        if ((tag.includes('torso') || tag.includes('body')) && !tag.includes('lego')) {
            console.log('Matched bodies via tag:', tag);
            return 'bodies';
        }
        if (tag.includes('accessory') || tag.includes('weapon') || tag.includes('tool')) {
            console.log('Matched accessories via tag:', tag);
            return 'accessories';
        }
        if ((tag.includes('display') || tag.includes('base')) && !tag.includes('lego')) {
            console.log('Matched display via tag:', tag);
            return 'display';
        }
    }

    console.log('No section match found, defaulting to accessories');
    return 'accessories';
};
